export default __webpack_public_path__ + "static/media/Sneak_Out_3D.43683ad3.jpg";